import { NavLink } from 'react-router-dom';
import styles from './Sidebar.module.scss';

export function Sidebar() {
  return (
    <aside className={styles.sidebar}>
      <nav className={styles.nav}>
        <NavLink to="/" className={({ isActive }) => (isActive ? styles.active : '')}>
          Dashboard
        </NavLink>
        <NavLink to="/projects" className={({ isActive }) => (isActive ? styles.active : '')}>
          Projects
        </NavLink>
        <NavLink to="/areas" className={({ isActive }) => (isActive ? styles.active : '')}>
          Areas
        </NavLink>
        <NavLink to="/devices" className={({ isActive }) => (isActive ? styles.active : '')}>
          Devices
        </NavLink>
        <NavLink to="/attributes" className={({ isActive }) => (isActive ? styles.active : '')}>
          Attributes
        </NavLink>
      </nav>
    </aside>
  );
}
